import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import { FONT_STACK, FontWeight, FontSize } from '../../../styles/constants';
import { propSwitch } from '../../../util/propSwitch';
import { LoadingStrip } from '../../LoadingStrip/LoadingStrip';
import { getTypeConfig } from '../getTypeConfig';

export interface TextProps {
  inverted?: boolean;
  small?: boolean;
  weight?: FontWeight;
}

export const Text = styled.p<TextProps>`
  color: ${propSwitch('inverted', ThemeColours.white, ThemeColours.mono700)};
  display: block;

  ${FONT_STACK}
  font-weight: ${FontWeight.REGULAR};
  margin-top: 0;
`;

export const StyledLoading = styled(LoadingStrip)`
  height: 26px;
  max-width: 280px;
`;

export const H1 = styled(Text).attrs({
  as: 'h1',
})(getTypeConfig('h1'));

export const H1Nav = styled(H1)`
  color: ${ThemeColours.white};
  margin-bottom: 40px;
  margin-top: 52px;
`;

export const H2 = styled(Text).attrs({
  as: 'h2',
})(getTypeConfig('h2'));

export const H3 = styled(Text).attrs({
  as: 'h3',
})(getTypeConfig('h3'));

export const H4 = styled(Text).attrs({
  as: 'h4',
})(getTypeConfig('h4'));

export const H5 = styled(Text).attrs({
  as: 'h5',
})(getTypeConfig('h5'));

export const Kicker = styled(Text).attrs({
  as: 'p',
})`
  font-size: ${FontSize.BODY_REGULAR};
  color: ${ThemeColours.primary500};
  margin-bottom: 5px;
`;
